<template>
  <div class="popup-wrapper">
    <form @submit.prevent>
      <div class="popup-container md">
        <div class="button close">
          <span role="button" class="btn" @click="operation.close">
            <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
          </span>
        </div>
        <div class="popup">
          <div class="popup-title">
            <span class="hdg02">表示件数</span>
          </div>
          <div class="popup-content">
              <div class="popup-content-block">
                <span class="txt mr20">1ページに表示する件数</span>
                <div class="formparts select"
                  @mouseenter="group1.visibleSelect = true"
                  @mouseleave="group1.visibleSelect = false"
                  :class="{ 'is-visible-list': group1.visibleSelect }"
                  >
                  <div class="select-label" role="select">{{group1.list_per_page.selected}}<FontawesomeIcon :icon="group1.visibleSelect ? 'angle-up' : 'angle-down'" class="icn" /></div>
                  <div v-if="group1.visibleSelect" class="select-option" ref="selectOption">
                    <ul class="select-option-list">
                      <li v-for="(list, index) in group1.list_per_page.lists" :key="'select_box_' + index" class="ta-center" role="option">
                        <label><input type="radio" @click="operation.onSelectChange" :value="list.value" name="group_rd_02">{{list.name}}</label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="popup-content-block">
                <div class="button mt32">
                  <button class="btn" type="submit"
                    @click="operation.submit"
                  >設定</button>
                </div>            
              </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'

export default defineComponent({
  setup (props, context) {

    const group1 = reactive({
      // 表示件数の選択肢表示フラグ
      visibleSelect: false,
      list_per_page: {
        selected: null,
        lists: [
          { value: 30, name: '30' },
          { value: 50, name: '50' },
          { value: 100, name: '100' }
        ]
      }
    })

    const operation = reactive({
      close: () => { context.emit('close') },
      submit: () => {
        store.dispatch('precedent/updateSearchSetting', { per_page: group1.list_per_page.selected })
        context.emit('submit')
      },
      onSelectChange: (event) => {
        const selectedValue = Number(event.target.value)
        group1.visibleSelect = false
        group1.list_per_page.selected = selectedValue
      }
    })

    onMounted(() => {
      group1.list_per_page.selected = store.state.precedent.searchSetting.per_page
    })

    return {
      group1,
      operation
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content {
    padding: 0!important;
    &-block {
      padding: 40px;
      & + .popup-content-block {
        border-top: 1px solid $color-line;
      }
      .txt {
        display: inline-block;
      }
      .formparts.select {
        display: inline-block;
      }
    }
  }
  .popup-content .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
</style>
